import { useAppSelector } from "@/utils";
import { Bank, CardList, Flex, Grid, Space, Typography } from "@payping/web-components";
import { DisplayModeEnum, ListCardProps } from "@payping/web-components/components/List/types";
import { formatLocalizedNumber } from "@payping/utilities-shared/number";
import { CuToman } from "@payping/icons";

const SamanShowList = () => {
  const paymentDetailsModels = useAppSelector((state) => state.digitalAccount.saman.requestList?.paymentDetailsModels);
  const { md } = Grid.useBreakpoint();

  const data: ListCardProps["dataSource"] = (paymentDetailsModels ?? []).map((transfer) => ({
    actions: [
      <Flex align="center" key={0}>
        <Typography.Text key={1}>{`${formatLocalizedNumber({ value: (transfer?.amount || 0) / 10 })}`}</Typography.Text>
        <CuToman width={24} height={24} />
      </Flex>,
    ],
    content: [
      <Flex key={1} vertical={!md} gap={16}>
        <Space>
          <Typography.Text type={"secondary"}>{transfer?.iban}</Typography.Text>
          <Bank.Icon showTooltip iban={transfer?.iban} />
        </Space>
      </Flex>,
    ],
    title: { primary: transfer.fullName },
    key: transfer.amount || "",
  }));

  return (
    <CardList
      grid={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1, column: 0 }}
      dataSource={data}
      mode={md ? DisplayModeEnum.List : DisplayModeEnum.Card}
    />
  );
};

export default SamanShowList;
